/**
 * Portadas para las tarjetas que no tienen imagen cargada (librerías de
 * BelivPedia, dashboards). Se asignan por contenido y no al azar en cada
 * render, así cada elemento se queda siempre con la misma y la grilla no se
 * intercambia al recargar o paginar.
 *
 * Para sumar portadas alcanza con dejar el archivo en la carpeta y agregarlo a
 * esta lista: cuantas más haya, menos se repiten entre tiles vecinos.
 */
export const DEFAULT_COVERS = [
  'assets/images/repository/covers/cover-01.png',
  'assets/images/repository/covers/cover-02.png',
  'assets/images/repository/covers/cover-03.png',
  'assets/images/repository/covers/cover-04.png'
];

/**
 * Devuelve la portada que le corresponde a un elemento. La semilla se hashea
 * como texto: los ids no siempre son numéricos (en las librerías son string),
 * y con Number() se obtenía NaN y todas caían en la misma portada.
 * @param seed Valor estable del elemento (code, id o título)
 */
export function defaultCover(seed?: string | number | null): string {
  const value = `${seed ?? ''}`;

  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) % 100003;
  }

  return DEFAULT_COVERS[hash % DEFAULT_COVERS.length];
}
